import axios from "axios";
let isSessionExpired = false;

const axiosInstance = axios.create({
  baseURL: 'https://wip.fibrebondindustries.com/api/',
  withCredentials: true
});

// Invalid login credentials must remain on the login form.
axiosInstance.interceptors.response.use(
  response => {
    const path = String(response.config?.url || '').split('?')[0];
    if (path.endsWith('/mis-dashboard') && response.data?.message !== 'Welcome MIS user') {
      const error = new Error('Session API returned an unexpected response. Check the /api reverse proxy.');
      error.response = response;
      throw error;
    }
    if (path.endsWith('/mis-login')) isSessionExpired = false;
    return response;
  },
  async error => {
    const path = String(error.config?.url || '').split('?')[0];
    const isLogin = path.endsWith('/mis-login');
    if (error.response?.status === 401 && !isLogin && !error.config?.skipSessionRedirect) {
      // A misrouted API can return another application's 401 while MIS is still valid.
      try {
        await axiosInstance.get('/mis-dashboard', { skipSessionRedirect: true, timeout: 12000 });
        error.userMessage = 'Your session is active, but this API rejected access. Please check the backend route deployment.';
        return Promise.reject(error);
      } catch (sessionError) {
        if (sessionError.response?.status !== 401) {
          error.userMessage = 'Unable to confirm your session. Please retry.';
          return Promise.reject(error);
        }
      }
      error.sessionExpired = true;
      if (!isSessionExpired) {
        isSessionExpired = true;
        sessionStorage.removeItem('auth');
        sessionStorage.removeItem('msalLogin');
        window.alert('Session expired. Please login again.');
        window.location.replace('/login');
      }
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
